import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class Tour extends Page{
    constructor(){
        super({
            id : 'tour',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}